module.exports = __webpack_public_path__ + "img/wf-work-example-metadata.d0f0ba48.svg";